import createIcon from '../../createIcon';

/**
 * @component @name Stars
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ3IDIyIDExLjk5IDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMS45OSAyWk0xNi4yMyAxOEwxMiAxNS40NUw3Ljc3IDE4TDguODkgMTMuMTlMNS4xNiA5Ljk2TDEwLjA4IDkuNTRMMTIgNUwxMy45MiA5LjUzTDE4Ljg0IDkuOTVMMTUuMTEgMTMuMThMMTYuMjMgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Stars = createIcon('Stars', [
  [
    'path',
    {
      d: 'M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM16.23 18L12 15.45L7.77 18L8.89 13.19L5.16 9.96L10.08 9.54L12 5L13.92 9.53L18.84 9.95L15.11 13.18L16.23 18Z',
      key: 's0q9x5',
    },
  ],
]);

export default Stars;
